//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dashboardCopy from "../../../../data/registrationDashboard.json"
import { mapGetters, mapMutations} from "vuex";
export default {
	name: "PageDashboard",
	data() {
		return{
			copy: dashboardCopy.registrationDashboard.default,
			copyEndpoint: '/api/userdashboard/getcontent/dashboard',
			logoutEndpoint: '/api/account/logout',
			copyHTML: '',
			footerHTML: '',
			alertHTML: '',
			optionalQuestions: {
				copy: '',
				heading: ''
			},
			// copyHTML1: '',
			// copyHTML2: '',
			isReminder: '',
			redirectURL: window.location.origin,
			isLoggedOut: false,
		}
	},
	computed: {
		...mapGetters(["optionalQuestionsDismissed", "isLoading"])
	},
	methods: { 
		...mapMutations(["setDisabled", "setLoading"]),
		logout() {
			return new Promise(async res => {
					await fetch(this.logoutEndpoint, {
						method: 'POST',
						headers: {
							'Content-type':'application/json'
						},
					})
					.then((response) => response.json())
					.then(data => {
						this.copyHTML = '<p class="registration-dashboard__title">Logout successful, now redirecting...</p>'
						this.isLoggedOut = true
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => {
						this.$parent.isLoggedIn = false
						setTimeout(() => {
							window.location = this.redirectURL
						}, 1500)
					});
				})
		},
		toggleOptionalQuestions(e) {
			if (!!e.target.closest('.registration-flyout__error-close')) return;
			this.$store.commit('setOptionalQuestions', true)
		},
		handleQuestionAlertClose(e) {
			const wrapper = e.target.closest('.registration-flyout__error-wrapper');
			this.$store.commit('setOptionalQuestions', false);
			window.localStorage.setItem('optionalQuestionsDismissed', true);
			wrapper.remove();
		}
	},
	mounted() {
		this.setLoading(true)
		fetch(this.copyEndpoint, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json'
			},
		}).then((response) => response.json())
			.then((data) => {
				this.copyHTML = data.content;
				this.footerHTML = data.footer;
				this.isReminder = data.reminder;
				this.alertHTML = data.alert;
				this.optionalQuestions = data.optionalQuestions;
				setTimeout(() => {
					this.setLoading(false);
					document.querySelector('dialog.registration-dialog')?.showModal();
				}, 1000);
			});
	},
};
